/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MinimalEventCategory } from './MinimalEventCategory';
export type MinimalEventWithCategory = {
    start: string;
    end: string;
    id: number;
    status: MinimalEventWithCategory.status;
    customTitle: string | null;
    category: MinimalEventCategory;
};
export namespace MinimalEventWithCategory {
    export enum status {
        OPEN = 'open',
        BOOKED = 'booked',
        ASSIGNED = 'assigned',
        APPROVED = 'approved',
        CANCELLED = 'cancelled',
        REJECTED = 'rejected',
        OUTAGE = 'outage',
        SKIPPED = 'skipped',
        MOVE_REQUESTED = 'move-requested',
    }
}

